// How many bars the report's record chart can show before it scrolls sideways, given the
// chart's outer width and the page's rem in px. The landing page fills its preview of the
// chart with exactly that many.
//
// The sizes mirror RecordRelativeValueChart in
// app/(authenticated)/report/components/Visualizations.tsx, and all but its 1 px border are
// in rem, so they grow with the browser's font size: pl-12 for the Min and Max labels, w-6
// bars with gap-1 between them, and under the last bar its label, a w-24 box turned 45° from
// the bar's middle, which reaches 6 × cos 45° rem past it. A pixel more is left for rounding.
// The preview renders the chart without its hover tooltips: hidden, they are still laid out,
// and one for a long marker name reaches far past the last label. Change these with the chart.
const BORDERS_PX = 2;
const ROUNDING_PX = 1;
const LEFT_PADDING = 3;
const BAR_PITCH = 1.75;
const HALF_BAR = 0.75;
const LABEL_REACH = 6 * Math.SQRT1_2;

// Everything but the pitch between bars: what a single bar needs.
const FIRST_BAR = LEFT_PADDING + HALF_BAR + LABEL_REACH;

export function recordChartBarsThatFit(
  chartWidth: number,
  remPx: number
): number {
  const room = (chartWidth - BORDERS_PX - ROUNDING_PX) / remPx - FIRST_BAR;
  return Math.max(0, Math.floor(room / BAR_PITCH) + 1);
}
